<template>
  <div v-show="isZnAlphaShow">
    <ZnTemplate ref="ZnTemplate" style="z-index:1004"></ZnTemplate>
    <div class="zn-alpha" style="z-index:1005">
      <div style="display:flex;flex-direction:column;height:100%">
        <div class="zn-alpha-title" @click="toggle">
          <span style="color:#fff;font-size:16px;margin:0 10px">智能小阿</span>
          <span style="color:#ffe481">（点击{{ isZnAlphaShow ? '收起' : '展开' }}对话框）</span>
        </div>
        <div class="zn-alpha-content" id="zn-content">
          <template v-for="(item, k) in messages">
            <!-- hello -->
            <div :key="k" v-if="item.name == 'hello'">
              <div class="zn-msg-hello">
                <div style="font-size:16px;">目录</div>
                <div v-for="(c, key) in item.children" :key="key" class="zn-msg-item">
                  <div class="zn-msg-link" @click="onClickItem(c)">{{ key + 1 }}、{{ c.label || c.name }}</div>
                </div>
              </div>
            </div>
            <!-- comfirm -->
            <div :key="k" v-else-if="item.msgType == 'comfirm'" class="zn-alpha-left">
              <div class="zn-avatar"></div>
              <div class="zn-msg">
                小阿发现您上次已经填写了{{ item.tpl.label }}，是否要继续填写？<br />
                <span class="zn-msg-link" @click="onClickComfirm(item.tpl)" style="margin-right:10px">继续填写</span>
                <span class="zn-msg-link" @click="onClickComfirm(item.tpl, true)">填写新的</span>
              </div>
            </div>
            <!-- downorview -->
            <div :key="k" v-else-if="item.msgType == 'downorview'" class="zn-alpha-left">
              <div class="zn-avatar"></div>
              <div class="zn-msg">
                您是想要 <span class="zn-msg-link" @click="preview({ md5: item.attachment.md5 })">查看该文件</span
                ><br />
                还是 <span class="zn-msg-link" @click="download({ md5: item.attachment.md5 })">直接下载</span>
              </div>
            </div>
            <!-- companyList -->
            <div :key="k" v-else-if="item.msgType == 'companyList'" class="zn-alpha-left">
              <div class="zn-avatar"></div>
              <div class="zn-msg">
                <span>{{ item.text }}</span
                ><br />
                <div v-for="(com, k) in item.children" :key="com._id" class="zn-msg-item">
                  <div
                    v-if="com.type == 'searchdrawer'"
                    class="zn-msg-link"
                    @click="searchDrawer(com.from, com.keyword)"
                  >
                    {{ com.text }}
                  </div>
                  <div v-else-if="com.label" class="zn-msg-link" @click="onClickItem(com)">
                    {{ k + 1 }}、{{ com.label }}
                  </div>
                  <div v-else class="zn-msg-link" @click="onChooseCompany(com)">
                    <el-popover placement="left" width="400" trigger="hover">
                      <div>
                        <div style="display:flex;padding-bottom:6px;">
                          <div style="padding-left:10px;flex:auto;">
                            <div style="margin-bottom:10px">
                              <span style="font-size:16px;font-weight:600;margin-right:10px;"
                                >{{ com.公司名称 }}（{{ com.简称 }}）</span
                              >
                            </div>
                            <div>
                              <span v-if="com.人员受认可度" class="zn-tag-warning"
                                >人员受认可度:{{ com.人员受认可度 }}</span
                              >
                              <span v-if="com.固定薪酬" class="zn-tag-warning">固定薪酬:{{ com.固定薪酬 }}</span>
                              <span v-if="com.激励机制" class="zn-tag-warning">激励机制:{{ com.激励机制 }}</span>
                              <span v-if="com.人员稳定性" class="zn-tag-warning">人员稳定性:{{ com.人员稳定性 }}</span>
                              <span v-if="com.平台等级" class="zn-tag-warning">平台等级:{{ com.平台等级 }}</span>
                              <span v-if="com.行业" class="zn-tag-warning">{{ com.行业 }}</span>
                              <span v-if="com.公司性质" class="zn-tag-warning">{{ com.公司性质 }}</span>
                              <span v-if="com.公司类型" class="zn-tag-warning">{{ com.公司类型 }}</span>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="com.客户开发 || com.项目对接"
                          style="display:flex;margin-top:10px;border-top:2px solid #eee;padding: 6px 10px;"
                        >
                          <span v-if="com.客户开发" class="zn-row-label" style="padding-right:30px;"
                            >客户开发：<span style="font-weight:800;color:#000;padding-left:10px;">{{
                              com.客户开发
                            }}</span></span
                          >
                        </div>
                        <div
                          v-if="com.一句话简介 || com.领导介绍"
                          style="padding: 6px 10px;border-top:2px solid #eee;flex-direction: column;"
                        >
                          <div v-if="com.一句话简介" style="padding:6px 6px 6px 0;">
                            <div class="zn-row-label">一句话介绍：</div>
                            <div style="white-space: pre-wrap;padding-left:20px">{{ com.一句话简介 }}</div>
                          </div>
                          <div v-if="com.领导介绍" style="padding:6px 6px 6px 0;">
                            <div class="zn-row-label">高管介绍：</div>
                            <div style="white-space: pre-wrap;padding-left:20px">{{ com.领导介绍 }}</div>
                          </div>
                        </div>
                      </div>
                      <span slot="reference">{{ k + 1 }}、{{ com.简称 }}</span>
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
            <!-- radishList -->
            <div :key="k" v-else-if="item.msgType == 'radishList'" class="zn-alpha-left">
              <div class="zn-avatar"></div>
              <div class="zn-msg">
                <span>{{ item.text }}</span
                ><br />
                <div v-for="(r, k) in item.children" :key="r._id" class="zn-msg-item">
                  <div v-if="r.type == 'searchdrawer'" class="zn-msg-link" @click="searchDrawer(r.from, r.keyword)">
                    {{ r.text }}
                  </div>
                  <div v-else class="zn-msg-link" @click="chooseRadish(r)">
                    {{ k + 1 }}、{{ r.姓名 }} {{ r.公司 }} {{ r.职能模块 && r.职能模块.toString() }}
                  </div>
                </div>
              </div>
            </div>
            <!-- projectList -->
            <div :key="k" v-else-if="item.msgType == 'projectList'" class="zn-alpha-left">
              <div class="zn-avatar"></div>
              <div class="zn-msg">
                <span>{{ item.text }}</span
                ><br />
                <div v-for="(p, k) in item.children" :key="p._id" class="zn-msg-item">
                  <div v-if="p.type == 'searchdrawer'" class="zn-msg-link" @click="searchDrawer(p.from, p.keyword)">
                    {{ p.text }}
                  </div>
                  <div v-else-if="p.label" class="zn-msg-link" @click="onClickItem(p)">{{ k + 1 }}、{{ p.label }}</div>
                  <div v-else class="zn-msg-link" @click="chooseProject(p)">
                    {{ k + 1 }}、{{ p.项目名称 }}-{{ p.客户公司 }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 宝藏 -->
            <div :key="k" v-else-if="item.msgType == 'onepiece'" class="zn-alpha-left">
              <div class="zn-avatar"></div>
              <div class="zn-msg">
                <span>{{ item.name }}：</span><br />
                <!-- 如何查看通讯录 -->
                <span v-if="item.name == '如何查看通讯录'">
                  在
                  <span class="zn-msg-link" @click="onClickAnswer('通讯录')">通讯录</span
                  >页面可以按照年份查看到各家公司的组织架构通讯录，公司通讯录是通过大家一点一点的收集来的，如果您也有某家公司的通讯录，可以点击
                  <span class="zn-msg-link" @click="onClickAnswer('通讯录上传')">通讯录上传</span
                  >，把通讯录上传到我们的系统，很快就会有数据同事专门整理您的通讯录然后传入对应年份的公司
                </span>
                <!-- 如何最快找到合适人选 -->
                <span v-else-if="item.name == '如何最快找到合适人选'">
                  您可以在
                  <span class="zn-msg-link" @click="onClickAnswer('推荐历史')">推荐历史</span
                  >页面找到最合适的人选，推荐历史中的人都是成功走到推荐阶段的候选人，说明人选比较合适，客户比较满意，同时人选意愿度也是最高的哦～
                </span>
                <!-- 如何查找人选 -->
                <span v-else-if="item.name == '如何查找人选'">
                  想要找更多的人进入项目吗？可以试试<span class="zn-msg-link" @click="onClickAnswer('人才快搜')"
                    >人才快搜</span
                  >
                </span>
                <!-- 如何查看人才流动 -->
                <span v-else-if="item.name == '如何查看人才流动'">
                  您可以在
                  <span class="zn-msg-link" @click="onClickAnswer('人才流动统计')">人才流动统计</span
                  >看到各家公司人员的流入流出动向。选择您想要查看的行业和时间就会出现流动图表
                </span>
                <!-- 如何了解行业 -->
                <span v-else-if="item.name == '如何了解行业'">
                  想要了解行业，您可以查看公司的
                  <span class="zn-msg-link" @click="onClickAnswer('知识库')">知识库</span
                  >，里面有大家一起累积起来的宝贵行业知识，认知，报告，助您成为行业大神～
                </span>
                <!-- 客户合作回顾统计 -->
                <span v-else-if="item.name == '客户合作回顾统计'">
                  如果您想要盘点一下和客户合作的情况，统计一下给客户一共推荐了多少人，具体什么情况，一共和该客户有多少个项目，可以试试
                  <span class="zn-msg-link" @click="onClickAnswer('客户公司合作回顾')">客户公司合作回顾</span>
                </span>
                <!-- 如何查看KPI -->
                <span v-else-if="item.name == '如何查看KPI'">
                  想要查看自己的KPI情况吗？点击
                  <span class="zn-msg-link" @click="onClickAnswer('KPI统计')">KPI统计</span>看看您今天的工作情况吧～
                  如果KPI统计里没有您，请找技术部的<span style="color:#c00">张学东</span>～
                </span>
                <!-- 如何查看体系化积分 -->
                <span v-else-if="item.name == '如何查看体系化积分'">
                  想要查看自己的体系化积分情况吗？点击
                  <span class="zn-msg-link" @click="onClickAnswer('体系化积分')">体系化积分</span
                  >看看您最近的积分情况吧～
                </span>
                <!-- 如何查看自己的成单情况 -->
                <span v-else-if="item.name == '如何查看自己的成单情况'">
                  想要查看自己都成了那些单子吗？点击
                  <span class="zn-msg-link" @click="onClickAnswer('发票')">发票</span
                  >看看最近的成绩吧，小阿祝您offer多多～
                </span>
                <!-- 公司血库预测 -->
                <span v-else-if="item.name == '公司血库预测'">
                  快速知道金主和血库在哪里，快来
                  <span class="zn-msg-link" @click="onClickAnswer('慧眼系统')">慧眼系统</span>看看吧
                </span>
              </div>
            </div>
            <!-- question -->
            <div :key="k" v-else-if="item.from == account" class="zn-alpha-right">
              <div class="zn-msg">{{ item.text }}</div>
              <div
                class="zn-avatar"
                :style="
                  `background-image: url('https://alphahr.oss-cn-beijing.aliyuncs.com/documents/upload/${account}.jpg');`
                "
              ></div>
            </div>
            <!-- tmp massage -->
            <div :key="k" v-else-if="item.msgType == 'tmp'" class="zn-alpha-left">
              <div class="zn-avatar"></div>
              <div class="zn-msg">{{ item.text }}</div>
            </div>
            <!-- 新建后 -->
            <div :key="k" v-else-if="item.msgType == 'new'" class="zn-alpha-left">
              <div class="zn-avatar"></div>
              <!-- 新建公司 -->
              <div v-if="item.cid" class="zn-msg">
                {{ item.text }} <br />
                {{ item.简称 || '' }} <span class="a-link" @click="openCompany(item.cid)">点击跳转公司</span>
              </div>
              <!-- 人选 -->
              <div v-else-if="item.rid" class="zn-msg">
                {{ item.text }} <br />
                {{ item.姓名 || '' }} <span class="a-link" @click="openRadish(item.rid)">点击跳转人选</span>
              </div>
              <!-- 新建项目 -->
              <div v-else-if="item.pid" class="zn-msg">
                {{ item.text }} <br />
                {{ item.项目名称 || '' }} <span class="a-link" @click="openProject(item.pid)">点击跳转项目</span>
              </div>
            </div>
            <!-- 培训 -->
            <div :key="k" v-else-if="item.type == '培训' && item.attachments" class="zn-alpha-left">
              <div class="zn-avatar"></div>
              <div class="zn-msg">
                <div>{{ item.text }}</div>
                <div v-for="(c, key) in item.attachments" :key="key" class="zn-msg-item">
                  <div class="zn-msg-link" @click="viewPeixun(c)">{{ key + 1 }}、{{ c.title }}</div>
                </div>
              </div>
            </div>
            <!-- 列表 -->
            <div :key="k" v-else class="zn-alpha-left">
              <div class="zn-avatar"></div>
              <div class="zn-msg">
                <div v-if="item.type == '制度'" v-html="item.text"></div>
                <div v-else>{{ item.text }}</div>
                <div v-for="(c, key) in item.children" :key="key" class="zn-msg-item">
                  <!-- 公司选项 -->
                  <div v-if="item.cid" class="zn-msg-link" @click="onClickItem(c, { cid: item.cid })">
                    {{ key + 1 }}、{{ c.label }}
                  </div>
                  <!-- 人选选项 -->
                  <div v-else-if="item.rid" class="zn-msg-link" @click="onClickItem(c, { rid: item.rid })">
                    {{ key + 1 }}、{{ c.label }}
                  </div>
                  <div v-else class="zn-msg-link" @click="onClickItem(c)">{{ key + 1 }}、{{ c.label || c.name }}</div>
                </div>
              </div>
            </div>
          </template>
          <!-- stream massage -->
          <div v-if="submiting&&!tempText" class="zn-alpha-left">
            <div class="zn-avatar"></div>
            <div class="zn-msg">小阿正在思考您的问题，请稍等...</div>
          </div>
          <div v-if="curAnswerText" class="zn-alpha-left">
            <div class="zn-avatar"></div>
            <div class="zn-msg">{{ tempText }}</div>
          </div>
        </div>
        <div class="zn-alpha-actions">
          <div class="zn-alpha-act" @click="addHello" title="查看目录" style="color:#fff;background:#91c0d4;">目录</div>
          <template v-for="(act, k) in znQuick">
            <div
              v-show="k < 3 || isAllActionShow"
              :key="k"
              class="zn-alpha-act"
              @click="onClickItem({ name: act })"
              title="常用的快捷填写，点击即可填写"
            >
              {{ act }}
            </div>
            <div
              v-if="k == 2"
              class="zn-alpha-act-all"
              @click="isAllActionShow = !isAllActionShow"
              title="可以收起展开更多填写项"
              style="float:right"
            >
              <i :class="isAllActionShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i
              >{{ isAllActionShow ? '收起' : '展开' }}
            </div>
            <br v-if="k == 2" />
          </template>
        </div>
        <div class="zn-alpha-input">
          <el-popover placement="left" trigger="click" width="200px">
            <span style="font-size:12px"
              >例：嘉实基金 薪酬<br />例：中金公司 流动（关键词之间空格分开）<br />关键词/短语例：<br />我要BD、拜访客户、离职辅导
              <br />以'小阿'开头问我，会有意外惊喜(*^▽^*)</span
            >
            <el-input
              slot="reference"
              type="textarea"
              :rows="3"
              placeholder="可输入例如： 嘉实基金 薪酬（空格分开）
或者输入关键词/短语：嘉实基金，我要去BD
以'小阿'开头问我，会有意外惊喜(*^▽^*)
"
              resize="none"
              v-model="znKeyword"
              @keyup.enter.native="search"
            >
            </el-input>
          </el-popover>
          <div class="zn-alpha-input-actions">
            <el-popover placement="top" trigger="click" popper-class="zn-act-all-pop">
              <div v-for="act in znTpls" :key="act" class="zn-act-all-item">
                <span @click="onClickItem({ name: act })">{{ act }}</span>
              </div>
              <i slot="reference" class="el-icon-notebook-2 zn-alpha-input-icon" title="工作中常用的模版"></i>
            </el-popover>
            <el-popover placement="top" trigger="click" popper-class="zn-act-all-pop">
              <div v-for="act in znFiles" :key="act" class="zn-act-all-item">
                <span @click="onClickItem({ name: act })">{{ act }}</span>
              </div>
              <i slot="reference" class="el-icon-download zn-alpha-input-icon" title="工作中需要下载的附件材料"></i>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="zn-template-actions">
        <template v-if="tplStatus == 'show'">
          <i class="el-icon-close zn-template-action" title="关闭" @click="closeTpl()"></i>
          <i class="el-icon-caret-right zn-template-action" title="收起" @click="hideTpl()"></i>
        </template>
        <i v-if="tplStatus == 'hide'" class="el-icon-caret-left" title="展开" @click="showTpl()"></i>
      </div>
    </div>
    <ProjectMember ref="ProjectMember"></ProjectMember>
    <bulletinAdd ref="bulletinAdd"></bulletinAdd>
  </div>
</template>
<script>
// const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay)) // 测试
import { download, preview } from '../../../project/src/constant/utils'
import ZnTemplate from './ZnTemplate'
import ProjectMember from './ProjectMember.vue'
import bulletinAdd from '../bulletin/bulletinAdd'
import { answers } from './zn_data'
export default {
  components: { ZnTemplate, ProjectMember, bulletinAdd },
  data() {
    return {
      isZnAlphaShow: false,
      isZnActionSettingShow: false,
      znKeyword: '',
      znQuick: ['沟通备注', '人选会面', '客户会面', '职能认知', '阿尔法认知', '新建项目', '新建公司'],
      znFiles: [
        'BD材料',
        '阿尔法合同',
        '背景调查',
        '营业执照',
        '人力资源许可证',
        '市场报告',
        '项目小结',
        '离职申请审批表',
        '每日复盘模板',
        '项目进展review',
      ],
      znTpls: [
        'BD邮件',
        'BD电话',
        '独家委托',
        '推荐确认',
        '推荐邮件',
        '试单推荐邮件',
        '承诺书',
        '离职辅导',
        '辞职信',
        '开票邮件',
        '催款邮件',
        '面试安排',
        '面试反馈',
      ],
      messages: [], // type: tmp/download/comfirm/downorview/companyList/radishList/projectList/new
      tplStatus: 'close',
      submiting: false,
      lastnzalpha: '',
      answers,
      waitInputType: '',
      waitAnswerId: '',
      prevZnId: '',
      isAllActionShow: false,
      linkMap: {
        通讯录: 'contactlists',
        推荐历史: 'cvinfoV2',
        人才快搜: 'radish2',
        人才流动统计: 'newTalentFlow',
        知识库: 'knowledgebase',
        KPI统计: 'kpi2',
        体系化积分: 'points',
        发票: 'offerTable',
        慧眼系统: 'forecast',
      },
      typeDetail: '',
      firstValue: '',
      secondValue: '',
      curAnswer:[],
      curAnswerText:"",
      tempText:""
    }
  },
  computed: {
    account() {
      return app.user.account
    },
  },
  watch:{
    submiting(val){
      console.log(val);
    }
  },
  methods: {
    async toggle() {
      this.isZnAlphaShow = !this.isZnAlphaShow
      if (this.isZnAlphaShow) {
        this.addHello()
      }
    },
    addMenu() {
      if (this.messages.length == 0 || this.messages[this.messages.length - 1].name != 'menu') {
        const item = this.answers.find(a => a.name == 'menu')
        this.addMsg(item)
      }
    },
    addHello() {
      if (this.messages.length == 0 || this.messages[this.messages.length - 1].name != 'hello') {
        const item = this.answers.find(a => a.name == 'hello')
        this.addMsg(item)
      }
    },
    insertRecord(type, content) {
      console.log('insertRecord', type, content)
      // 保存记录 type:关键词/点击选项/点击菜单/查看培训/查看宝藏
      const item = {
        from: this.account,
        to: 'admin',
        createdAt: Date.now(),
        msgType: type,
        content,
      }
      app.service('communication').insertAlphaChatRecords(item)
    },
    async search(param) {
      try {
        if (this.submiting) {
          this.$message('小阿正在为您查询，请耐心等待哦')
          return this.addTmpMsg('小阿正在为您查询，请耐心等待哦')
        }
        this.submiting = true
        let keyword = (param && param.keyword) || this.znKeyword
        keyword = keyword.trim()
        if (!keyword) {
          this.addTmpMsg('请输入查询内容')
          return (this.submiting = false)
        }
        this.addQuestion(keyword)
        this.insertRecord('关键词', keyword)
        keyword = keyword.toLowerCase()
        if (keyword.includes('小阿') || keyword.includes('小啊')) {
          const valiadKeyword = keyword.slice(3).trim()
          if (valiadKeyword) {
            this.znKeyword = ''
            const chatRes = await app.service('communication').chatWithGpt({ keyword: valiadKeyword })
            this.intervalGetResult(chatRes.data.logId)
            return
          }
        } else {
          // 原小阿逻辑
          const index = keyword.lastIndexOf(' ')
          let firstValue = ''
          let secondValue = ''
          if (index === -1) {
            firstValue = keyword
          } else {
            firstValue = keyword.substring(0, index).trim()
            secondValue = keyword.substring(index + 1).trim()
          }
          this.firstValue = firstValue
          this.secondValue = secondValue
          console.log('search', firstValue, secondValue)
          if (this.waitInputType) {
            const typeRes = await this.getTypeAndData({ type: this.waitInputType, keyword })
            if (!typeRes) {
              this.addTmpMsg(`没有找到结果，请重新输入${this.waitInputType}`)
              return this.clearInput()
            }
            if (this.waitInputType == '公司') {
              this.handleCompany(typeRes.data)
            } else if (this.waitInputType == '项目') {
              this.handleProject(typeRes.data)
            } else {
              this.handleRadish(typeRes.data)
            }
            return this.clearInput()
          }
          let answerRes = false
          if (secondValue) {
            // 两个关键词
            if (/(list)|(通讯录)/.test(secondValue)) {
              // 公司+通讯录
              keyword = firstValue
              const typeRes = await this.getTypeAndData({ type: '公司', keyword: firstValue })
              this.typeDetail = '公司+通讯录'
              this.handleCompany(typeRes.data)
              return this.clearInput()
            } else if (/沟通/.test(secondValue)) {
              // 姓名+沟通备注
              this.waitAnswerId = '5-1-0'
              const typeRes = await this.getTypeAndData({ type: '人选', keyword: firstValue })
              this.handleRadish(typeRes.data)
              return this.clearInput()
            } else if (/招聘/.test(secondValue)) {
              // 公司/职能+招聘
              const answer = this.answers.find(a => a.id == '9-5')
              this.openTemplate(Object.assign({ keyword: firstValue.trim().toUpperCase() }, answer))
              return this.clearInput()
            } else if (/(情报)|(变动)|(资讯)|(新闻)/.test(secondValue)) {
              const typeRes = await this.getTypeAndData({ type: '公司', keyword: firstValue })
              if (typeRes && typeRes.data.length > 0) {
                // 公司+情报
                window.open(`${window.frontend}/#/bulletins?company=${typeRes.data[0].简称}`)
              } else {
                // 职能模块+情报
                window.open(`${window.frontend}/#/bulletins?cate=${firstValue}`)
              }
              return this.clearInput()
            } else {
              // 公司+职能认知/阿尔法认知/薪酬/高管/流入流出/面试地址/推荐须知
              const ids = ['2-1', '2-2', '2-3', '2-4', '2-5', '2-8', '10-3']
              const answer = this.answers.find(a => ids.includes(a.id) && a.keywords.includes(secondValue))
              if (answer) {
                this.waitAnswerId = answer.waitAnswerId
                const typeRes = await this.getTypeAndData({ type: '公司', keyword: firstValue })
                this.handleCompany(typeRes.data)
                return this.clearInput()
              }
            }
          } else {
            // 搜索话术树
            answerRes = this.searchAnswer(keyword)
          }
          if (!answerRes) {
            const typeRes = await this.getTypeAndData({ keyword })
            // console.log('typeRes', typeRes)
            if (typeRes) {
              if (typeRes.type == '公司') {
                if (typeRes.detail == '公司+职能模块') {
                  this.waitAnswerId = '2-1'
                }
                this.handleCompany(typeRes.data)
              } else if (typeRes.type == '人选') {
                this.handleRadish(typeRes.data)
              } else {
                this.handleProject(typeRes.data)
              }
            } else {
              this.addTmpMsg('没有找到结果')
              this.addMenu()
            }
          }
        }
        return this.clearInput()
      } catch (e) {
        console.error(e)
        return this.clearInput()
      }
    },
    clearInput() {
      this.znKeyword = ''
      this.submiting = false
      return false
    },
    async getTypeAndData(param) {
      this.typeDetail = ''
      this.category = ''
      const res = await app.service('communication').getTypeAndDataByKeywords(param)
      // console.log('getTypeAndData', res)
      if (res.status == 'success' && res.data && res.data.data.length > 0) {
        this.typeDetail = res.data.detail
        return res.data
      } else {
        return false
      }
    },
    async handleCompany(coms) {
      if (coms) {
        coms = coms.map(c => {
          c.waitAnswerId = this.waitAnswerId
          c.prevZnId = this.prevZnId
          return c
        })
        if (coms.length > 1) {
          if (coms.length == 10) {
            coms.push({
              type: 'searchdrawer',
              from: '公司',
              text: '>> 查看更多公司',
              keyword: this.firstValue,
            })
          }
          this.addMsg({
            msgType: 'companyList',
            text: '您要找的是不是：',
            children: coms,
          })
        } else {
          this.chooseCompany(coms[0])
        }
      } else {
        this.addMsg({
          text: '没有找到公司，要新建一个吗？',
          children: [{ id: '1-1', label: '新建公司' }],
        })
      }
      this.waitInputType = ''
      this.waitAnswerId = ''
    },
    onChooseCompany(com) {
      this.addQuestion(com.简称)
      this.chooseCompany(com)
    },
    chooseCompany(com) {
      console.log('chooseCompany', com, this.typeDetail)
      const answer = com.waitAnswerId
        ? this.answers.find(a => a.id == com.waitAnswerId)
        : this.answers.find(a => a.name == 'company')
      const item = Object.assign({ cid: com._id }, answer)
      if (this.typeDetail == '公司+职能模块') {
        // 公司+职能模块
        item.category = this.secondValue
      } else if (this.typeDetail == '公司+通讯录') {
        // 公司+通讯录
        return window.open(`${window.frontend}/#/contactlists?companyName=${com.简称}`)
      }
      if (answer.children) {
        this.addMsg(item)
      } else if (answer.isLink) {
        if (answer.id == '2-9-0') {
          // 打开通讯录
          window.open(`${window.frontend}/#/contactlists?companyName=${com.简称}`)
        } else {
          // 打开公司
          this.openCompany(item.cid, answer.activeTab)
        }
      } else {
        if (com.prevZnId === '1-10') item.autoDownload = true
        this.openTemplate(item)
      }
    },
    async handleRadish(radishes) {
      if (radishes) {
        radishes = radishes.map(c => {
          c.waitAnswerId = this.waitAnswerId
          return c
        })
        if (radishes.length > 1) {
          if (radishes.length == 10) {
            radishes.push({
              type: 'searchdrawer',
              from: '人选',
              text: '>> 查看更多人选',
              keyword: this.firstValue,
            })
          }
          this.addMsg({
            msgType: 'radishList',
            text: '您要找的是不是：',
            children: radishes,
          })
        } else {
          this.chooseRadish(radishes[0])
        }
      } else {
        this.addTmpMsg('没有找到人选')
        this.addMenu()
      }
      this.waitInputType = ''
      this.waitAnswerId = ''
    },
    chooseRadish(radish) {
      console.log('chooseRadish', radish)
      this.addQuestion(radish.姓名 + (radish.公司 ? ' ' + radish.公司 : ''))
      const answer = radish.waitAnswerId
        ? this.answers.find(a => a.id == radish.waitAnswerId)
        : this.answers.find(a => a.name == 'radish')
      const item = Object.assign({ rid: radish._id }, answer)
      if (answer.children) {
        this.addMsg(item)
      } else {
        this.openTemplate(item)
      }
    },
    async handleProject(pros) {
      if (pros) {
        if (pros.length > 1) {
          if (pros.length == 10) {
            pros.push({
              type: 'searchdrawer',
              from: '项目',
              text: '>> 查看更多项目',
              keyword: this.znKeyword.trim(),
            })
          }
          this.addMsg({
            msgType: 'projectList',
            text: '您要找的是不是：',
            children: pros,
          })
        } else {
          this.chooseProject(pros[0])
        }
      } else {
        this.addTmpMsg('没有找到项目')
        this.addMenu()
      }
      this.waitInputType = ''
      this.waitAnswerId = ''
    },
    chooseProject(pro) {
      console.log('chooseProject', pro)
      this.addQuestion(pro.项目名称)
      // 打开右侧小页
      app.root.onPull()
      app.root.$refs.drawer.changeSearchType('项目')
      this.$nextTick(() => {
        const p = app.root.$refs.drawer.$refs.ProjectComponent
        p.searchProjects = [pro]
        p.isSearch = true
        p.getProjectDetail({ id: pro._id })
      })
    },
    searchDrawer(type, keywords) {
      app.root.onPull()
      app.root.$refs.drawer.search({ type, keywords })
    },
    checkPhone(phone) {
      if (phone) {
        phone = phone.replace(/[^0-9]/g, '').replace(/^86(.*?)/, '$1')
        if (phoneVali(phone)) {
          return phone
        }
      }
      return false
    },
    searchAnswer(keyword) {
      let answers = []
      // 优先完全匹配的
      answers = this.answers.filter(a => a.keywords && a.keywords.includes(keyword))
      if (answers.length == 0) {
        answers = this.answers.filter(a => {
          if (a.keywords) {
            return a.keywords.find(kw => keyword.indexOf(kw) !== -1)
          }
          return false
        })
      }
      if (answers.length > 0) {
        if (answers[0].name == 'menu') {
          this.addMenu()
          return true
        }
        this.addMsg({
          text: '您要找的是不是：',
          children: [].concat(answers),
        })
        return true
      }
      return false
    },
    addOnepiece(answer) {
      this.addMsg({
        msgType: 'onepiece',
        name: answer.name,
      })
      if (answer.next) {
        const nextItems = this.answers.filter(a => answer.next.includes(a.id))
        if (nextItems.length > 0) {
          this.addMsg({
            text: '您是不是还想找：',
            children: [].concat(nextItems),
          })
        }
      }
      this.scrollToBottom()
    },
    // addPeixun(answer) {
    //   this.addMsg(answer)
    //   if (answer.next) {
    //     const nextItems = this.answers.filter(a=>answer.next.includes(a.id))
    //     if (nextItems.length > 0) {
    //       this.addMsg({
    //         text: '您是不是还想找：',
    //         children: [].concat(nextItems),
    //       })
    //     }
    //   }
    //   this.scrollToBottom()
    // },
    viewPeixun(item) {
      app.root.$refs.PeixunDia.open(item)
      this.insertRecord('查看培训', item.title)
    },
    onClickAnswer(type) {
      switch (type) {
        case '通讯录上传':
          app.root.$refs.nav && app.root.$refs.nav.uploadList()
          break
        case '客户公司合作回顾':
          app.root.$refs.nav && app.root.$refs.nav.showCompanyReport()
          break

        default:
          window.open(`${window.frontend}/#/${this.linkMap[type]}`)
          break
      }
      this.insertRecord('查看宝藏', type)
    },

    async getCanyu() {
      const canyuRes = await app.service('radish').findProjectByRid({ rid: this.$route.params.id })
      // console.log('getCanyu', canyuRes)
      if (canyuRes.status == 'success' && canyuRes.data.length > 0) {
        const pMap = {
          Call: 1,
          推荐: 2,
          面试: 3,
          终面: 4,
          offer谈判: 5,
          离职辅导: 6,
          到岗: 7,
          过保: 8,
          未过保: 9,
          已放弃: 10,
          已淘汰: 10,
        }
        const pros = canyuRes.data
          .sort((a, b) => {
            const pA = Array.isArray(a.人选进展阶段) ? a.人选进展阶段[0] : a.人选进展阶段
            const pB = Array.isArray(b.人选进展阶段) ? b.人选进展阶段[0] : b.人选进展阶段
            if (pMap[pA] < pMap[pB]) {
              return 1
            } else if (pMap[pA] == pMap[pB]) {
              return a.createdAt < b.createdAt ? 1 : -1
            } else {
              return -1
            }
          })
          .map(p => {
            p._id = p.pid
            return p
          })
          .slice(0, 10)
        pros.push({
          id: '6-0',
          label: '不是以上项目，我要自己输入',
        })
        this.addMsg({
          msgType: 'projectList',
          text: '小阿发现该人选参与了以下项目，您想看哪个？',
          children: pros,
        })
        return true
      }
      return false
    },
    async getRadishCompany() {
      const radishRes = await app.service('radish').simpleFetch({
        _id: this.$route.params.id,
        fields: { 姓名: 1, 公司: 1 },
      })
      if (radishRes.status == 'success' && radishRes.data && radishRes.data.公司) {
        const res = await app.service('company').getCompany({ 简称: radishRes.data.公司 })
        if (res.status === 200 && res.result && res.result._id) {
          this.addMsg({
            msgType: 'companyList',
            text: '您是否想看：',
            children: [
              Object.assign({ waitAnswerId: '3-2-0-0' }, res.result),
              {
                id: '3-2-0',
                label: '不是，我要看别的公司',
              },
            ],
          })
          return true
        }
      }
      return false
    },

    async onClickItem(item, otherParam) {
      try {
        this.waitInputType = ''
        if (item.label) {
          // console.log(1)
          this.addQuestion(item.label)
          const answer = this.answers.find(a => a.id == item.id)
          item = Object.assign({}, answer)
          this.insertRecord('点击选项', item.name)
        } else {
          // console.log(2)
          this.addQuestion(item.name)
          if (!item.id) {
            const answer = this.answers.find(a => a.name == item.name)
            if (answer) {
              item = Object.assign({}, answer)
              this.insertRecord('点击菜单', item.name)
            } else {
              item = {}
            }
          } else {
            this.insertRecord('点击选项', item.name)
          }
        }
        console.log('onClickItem', item, otherParam)
        // app.service('project').saveRecords({ type: item.简称, path: item.模板名称?'点击对话':'点击菜单', page: '智能小阿' })
        if (this.$route.name == 'radish-detail-blank') {
          // 在人选详情页
          if (item.id == '6') {
            // 优先出人选参与项目
            const cyres = await this.getCanyu()
            if (cyres) return
          } else if (item.id == '3-2') {
            // 优先出人选公司介绍及高管
            const comRes = await this.getRadishCompany()
            if (comRes) return
          } else if (['5-1', '5-3', '5-4'].includes(item.id) && (!otherParam || !otherParam.rid)) {
            // 当前人选沟通备注及认知
            const answer = this.answers.find(a => a.id == item.waitAnswerId)
            item = answer ? Object.assign({}, answer) : {}
          }
        }

        if (otherParam) {
          if (otherParam.cid) {
            // 公司相关
            if (item.isLink) return this.openCompany(otherParam.cid, item.activeTab)
            if (item.waitAnswerId) {
              const answer = this.answers.find(a => a.id == item.waitAnswerId)
              item = answer ? Object.assign({}, answer) : {}
            }
            item.cid = otherParam.cid
          }
          if (otherParam.rid) {
            // 人选相关
            if (item.isLink) return this.openRadish(otherParam.rid)
            if (item.waitAnswerId) {
              const answer = this.answers.find(a => a.id == item.waitAnswerId)
              item = answer ? Object.assign({}, answer) : {}
            }
            item.rid = otherParam.rid
          }
        } else if (item.id == '20-1') {
          // 弹出新增人选
          return app.root.$refs.nav && app.root.$refs.nav.addRadish()
        } else if (item.id == '20-2') {
          // 弹出通讯录上传
          return app.root.$refs.nav && app.root.$refs.nav.uploadList()
        } else if (item.path) {
          return window.open(`${window.frontend}/#/${item.path}`)
        }
        if (item.type == '附件') {
          // 下载
          if (item.attachments.length == 1) {
            this.addMsg({ msgType: 'downorview', attachment: item.attachments[0] })
          } else {
            this.addMsg({ msgType: 'download', attachments: item.attachments })
          }
        } else if (item.type == '解析模板') {
          const checkRes = this.$refs.ZnTemplate.checkLocal(item)
          if (checkRes) {
            return this.addMsg({ msgType: 'comfirm', tpl: item })
          }
          this.openTemplate(item)
        } else if (item.type == '话术模板' || item.type == '其他') {
          this.openTemplate(item)
        } else if (item.type == '宝藏') {
          this.addOnepiece(item)
        } else if (item.type == '培训') {
          // this.addPeixun(item)
          this.viewPeixun(item.attachment)
        } else if (item.name == '新增情报') {
          this.$refs.bulletinAdd.show({ bulletinsType: null, formData: null })
        } else {
          this.prevZnId = item.id
          if (item.waitInputType) {
            this.waitInputType = item.waitInputType
          }
          if (item.waitAnswerId) {
            this.waitAnswerId = item.waitAnswerId
          }
          item.text ? this.addMsg(item) : this.addTmpMsg('功能开发中')
        }
      } catch (e) {
        console.error(e)
      }
    },
    openTemplate(item, withoutDefault) {
      const msg = item.type == '解析模板' ? `收到！${item.name}已经打开，请填写` : `好的，小阿正在为您打开${item.name}`
      this.addTmpMsg(msg)
      this.$nextTick(() => {
        const openRes = this.$refs.ZnTemplate.open(item, withoutDefault)
        if (!openRes) return this.addTmpMsg('无法找到对应模版')
        this.tplStatus = 'show'
      })
    },
    onClickComfirm(item, withoutDefault) {
      this.addQuestion(withoutDefault ? '填写新的' : '继续填写')
      this.openTemplate(item, withoutDefault)
    },
    scrollToBottom: function() {
      this.$nextTick(() => {
        const container = this.$el.querySelector('#zn-content')
        container.scrollTop = container.scrollHeight
      })
    },
    addMsg(item) {
      console.log('addMsg', item)
      this.messages.push(Object.assign({ from: 'admin' }, item))
      this.scrollToBottom()
    },
    intervalGetResult(logId, sId, text) {
      let timer = null
      let isEnd = false
      let sentenceId = sId
      const map = new Map()
      let sentenceTimer = null
      let sentenceNum = 0
      sentenceTimer = setInterval(async() => {
        if (isEnd && this.tempText === this.curAnswerText) {
          sentenceTimer && clearInterval(sentenceTimer)
          this.$nextTick(() => {
            this.scrollToBottom()
          })
          this.messages.push({ msgType: 'tmp', text: this.curAnswerText })
          this.curAnswer = []
          this.curAnswerText = ''
          this.tempText = ''
          this.submiting = false

          return
        }
        if (this.curAnswerText[sentenceNum]) {
          this.tempText += this.curAnswerText[sentenceNum]
          sentenceNum++
          this.$nextTick(() => {
            this.scrollToBottom()
          })
        }
      }, 50)
      timer = setInterval(async() => {
        if (isEnd) {
          timer && clearInterval(timer)
          return
        }
        const result = await this.getLeftResults(logId, sentenceId)
        if (result.lastSentenceId) {
          sentenceId = result.lastSentenceId
        }
        if (result.isEnd) {
          isEnd = result.isEnd
        }

        this.curAnswer.push(
          ...(result.data
            .map((item) => ({
              sentence_id: item.index,
              result: item.choices[0].delta.content
            }))
            .filter(
              (item) =>
                !map.has(item.sentence_id) && map.set(item.sentence_id, 1)
            ) || [])
        )
        this.curAnswerText = this.curAnswer.map((c) => c.result).join('')
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }, 3000)
    },
    async getLeftResults(logId, sId) {
      const sentenceId = sId || 0
      const res = await window.app
        .service('communication')
        .getLeftResults({ logId, sentenceId })
      return res.data
    },
    addTmpMsg(msg) {
      this.messages.push({ msgType: 'tmp', text: msg })
      this.scrollToBottom()
    },
    addQuestion(msg) {
      this.messages.push({ from: this.account, text: msg })
      this.scrollToBottom()
    },
    addComfirmMsg(msg, componentName) {
      this.messages.push({ msgType: 'comfirm', text: msg, componentName })
      this.scrollToBottom()
    },
    showTpl() {
      this.tplStatus = 'show'
      this.$refs.ZnTemplate.show()
    },
    hideTpl() {
      this.tplStatus = 'hide'
      this.$refs.ZnTemplate.close()
    },
    closeTpl(param) {
      this.tplStatus = 'close'
      this.$refs.ZnTemplate.close()
      if (param) {
        const { msg, other } = param
        if (other) {
          this.addMsg(Object.assign({ text: msg }, other))
          if (other.pid) {
            this.$refs.ProjectMember.open(other.pid)
          }
        } else if (msg) {
          this.addTmpMsg(msg)
        }
      }
    },
    openCompany(cid, activeTab) {
      if (activeTab) {
        window.open(`${window.frontend}/#/company/${cid}?tab=${activeTab}`)
      } else {
        window.open(`${window.frontend}/#/company/${cid}`)
      }
    },
    openRadish(rid) {
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}`)
    },
    openProject(pid) {
      window.open(`${window.frontend}/#/project20/${pid}`)
    },
    download(param) {
      download(param)
      this.addTmpMsg('小阿已为您下载文件到左下角')
      this.insertRecord('下载附件', param.md5)
    },
    async preview(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return this.addTmpMsg('预览失败')
      ref.getFile(file)
      ref.show()
      this.addTmpMsg('小阿已在左边为您打开了预览')
      this.insertRecord('查看附件', file.md5)
    },
  },
}
</script>
<style>
.zn-alpha {
  position: fixed;
  top: 60px;
  bottom: 100px;
  width: 20%;
  right: 1px;
  background-color: #2478b5;
  border-radius: 4px;
  padding: 1px;
}
.zn-alpha-title {
  padding: 5px;
  cursor: pointer;
  height: 32px;
}
.zn-alpha-content {
  overflow-y: auto;
  background-color: #fff;
  margin-top: 5px;
  flex: 1;
}
.zn-alpha-left {
  padding: 5px 45px 5px 5px;
  display: flex;
  justify-content: flex-start;
}
.zn-alpha-right {
  padding: 5px 5px 5px 45px;
  display: flex;
  justify-content: flex-end;
}
.zn-avatar {
  width: 30px;
  height: 30px;
  background-size: cover;
  border-radius: 50%;
}
.zn-alpha-left .zn-avatar {
  background: #f3f3f3 url('https://alphahr.oss-cn-beijing.aliyuncs.com/documents/upload/znalpha.png') center/22px 22px
    no-repeat;
  margin-right: 10px;
}
.zn-alpha-right .zn-avatar {
  margin-left: 10px;
}
.zn-msg {
  padding: 5px 8px;
  flex: 1;
  border-radius: 4px;
  line-height: 1.5;
  white-space: pre-line;
}
.zn-msg-hello {
  border: 2px solid #91c0d4;
  padding: 5px 10px;
  margin: 10px 15px;
  border-radius: 4px;
  line-height: 1.5;
}
.zn-msg-hello .zn-msg-link {
  font-size: 14px;
  padding-left: 15px;
}
.zn-msg-item {
  display: flex;
  justify-content: space-between;
}
.zn-alpha-left .zn-msg {
  background-color: #fafafa;
  box-shadow: 0 0 2px #bbb;
}
.zn-alpha-right .zn-msg {
  background-color: #6c6;
  line-height: 20px;
  max-width: fit-content;
}
.zn-msg-link {
  color: #0472c7;
  cursor: pointer;
  margin-right: 5px;
}
.zn-msg-link:hover {
  text-decoration: underline;
}
.zn-alpha-actions {
  padding: 5px 2px 2px 5px;
  margin-top: 1px;
  background: #fff;
}
.zn-alpha-act {
  display: inline-block;
  color: #467388;
  background-color: #fff;
  border: 1px solid #467388;
  padding: 0 5px;
  text-align: center;
  cursor: pointer;
  margin-right: 3px;
  margin-bottom: 3px;
}
.zn-alpha-act-all {
  display: inline-block;
  color: #467388;
  padding: 0 5px;
  cursor: pointer;
}
.zn-alpha-act-all i {
  font-weight: 900;
}
.zn-alpha-content::-webkit-scrollbar-thumb {
  background-color: #cfe3ec;
}
.zn-act-all-item {
  line-height: 26px;
  padding: 0 10px;
  color: #467388;
  cursor: pointer;
  border-top: 1px solid #ecf6fa;
}
.zn-act-all-item:hover {
  background-color: #2478b5;
  color: #fff;
}
.zn-act-all-item input {
  margin-right: 5px;
  position: relative;
  top: 1px;
}
.el-popover.zn-act-all-pop {
  padding: 5px 0;
  width: 120px;
  min-width: 120px;
}
.zn-act-setting {
  text-align: right;
  color: #2478b5;
  font-size: 12px;
  padding-right: 5px;
  cursor: pointer;
}
.zn-template-actions {
  position: fixed;
  top: 61px;
  right: 20%;
  padding: 8px 1px 0 0;
}
.zn-template-action {
  width: 30px;
  height: 30px;
  color: #999;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  font-weight: bold;
  background-color: #fff;
  cursor: pointer;
}
.zn-template-action:hover {
  color: #666;
}
.zn-template-actions .el-icon-caret-left {
  width: 30px;
  height: 30px;
  background-color: #2478b5;
  color: #fff;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  border-radius: 4px 0 0 4px;
  margin-right: -2px;
}
.zn-alpha-input {
  position: relative;
  padding: 0 5px 5px 5px;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
.zn-alpha-input .el-textarea .el-textarea__inner {
  padding: 30px 5px 5px 5px;
  font-size: 12px;
}
.zn-alpha-input-actions {
  position: absolute;
  top: 5px;
  left: 10px;
}
.zn-alpha-input-icon {
  width: 20px;
  height: 20px;
  margin-right: 3px;
  display: inline-block;
  color: #999;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
}

.zn-tag-warning {
  display: inline-block;
  padding: 4px;
  color: #fff;
  background-color: #f6c57b;
  border-radius: 4px;
  margin-bottom: 5px;
  margin-right: 10px;
  white-space: nowrap;
  font-size: 12px;
}
.zn-row-label {
  flex: none;
  color: #a3a3a3;
  margin-right: 6px;
  min-width: 72px;
}
</style>
